// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Dh9r","title":"Images45_title__2ZVzX","images":"Images45_images__1iosZ"};